var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('BTable', {
    attrs: {
      "items": _vm.value,
      "fields": _vm.tableFields
    },
    scopedSlots: _vm._u([{
      key: "cell(label)",
      fn: function (data) {
        return [_c('BInput', {
          attrs: {
            "disabled": _vm.disabled
          },
          model: {
            value: data.item.label,
            callback: function ($$v) {
              _vm.$set(data.item, "label", $$v);
            },
            expression: "data.item.label"
          }
        })];
      }
    }, {
      key: "cell(value)",
      fn: function (data) {
        return [_c('BInput', {
          attrs: {
            "disabled": _vm.disabled
          },
          model: {
            value: data.item.value,
            callback: function ($$v) {
              _vm.$set(data.item, "value", $$v);
            },
            expression: "data.item.value"
          }
        })];
      }
    }, {
      key: "cell(delete)",
      fn: function (data) {
        return [_c('OmniButton', {
          staticClass: "float-right",
          attrs: {
            "icon": "trash",
            "variant": "danger",
            "disabled": _vm.disabled
          },
          on: {
            "click": function ($event) {
              return _vm.deleteMenuItem(data.index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t(`frontend-parameters.parameters.order-details.${_vm.parameter.key}.button-remove`)))])];
      }
    }, {
      key: "bottom-row",
      fn: function () {
        return [_c('td', [_c('BFormInput', {
          attrs: {
            "placeholder": _vm.$t(`frontend-parameters.parameters.order-details.${_vm.parameter.key}.label-placeholder`),
            "disabled": _vm.disabled
          },
          model: {
            value: _vm.newMenuItem.label,
            callback: function ($$v) {
              _vm.$set(_vm.newMenuItem, "label", $$v);
            },
            expression: "newMenuItem.label"
          }
        })], 1), _c('td', [_c('BFormInput', {
          attrs: {
            "placeholder": _vm.$t(`frontend-parameters.parameters.order-details.${_vm.parameter.key}.value-placeholder`),
            "disabled": _vm.disabled
          },
          model: {
            value: _vm.newMenuItem.value,
            callback: function ($$v) {
              _vm.$set(_vm.newMenuItem, "value", $$v);
            },
            expression: "newMenuItem.value"
          }
        })], 1), _c('td', [_c('OmniButton', {
          staticClass: "float-right",
          attrs: {
            "icon": "circle-plus",
            "disabled": !_vm.formValid || _vm.disabled
          },
          on: {
            "click": _vm.addMenuItem
          }
        }, [_vm._v(_vm._s(_vm.$t(`frontend-parameters.parameters.order-details.${_vm.parameter.key}.button-add`)))])], 1)];
      },
      proxy: true
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }